import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { Response } from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import {
	GetInvestorBankAccountsRes,
	ListInvestorBankAccountsDto,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const getMipInvestorBankAccounts = async (
	args: ListInvestorBankAccountsDto,
	options?: ServiceRequestOptions
) => {
	const response = await makeRequest<Response<GetInvestorBankAccountsRes>>(
		{
			endpoint: API_PATHS.MIP_INVESTOR_BANK_ACCOUNT_LIST_POST,
			method: HTTP_METHOD.POST,
			body: JSON.stringify(args),
		},
		{ ...options }
	);

	return response;
};
